const allLogs=()=>{
  console.error = () => {};
  console.warn = () => { };
  console.info = () => { };
  console.log = () => {};
  console.trace = () => {};
}


const infoLogs=()=>{
console.info = () => { };
}

const warnLogs=()=>{
  console.warn = () => { };
  }


export const ignore={
  warnLogs,infoLogs,allLogs
}